export default "__VITE_ASSET__CBBDoq3C__"